import { TournamentBracket } from '../../../landing/activity/bracketView';
import { WebActivityCategory, WebActivityMatch } from '../../../webInterface';

type BracketProps = {
    matches: WebActivityMatch[];
    roundNames: string[] | undefined;
    category: WebActivityCategory | undefined;
};

const App: React.FC<BracketProps> = ({ matches, category, roundNames }) => {
    if (!matches?.length || !category) {
        return null;
    }

    return (
        <TournamentBracket
            matches={matches}
            roundNames={roundNames || category.round_names}
            hasExtraMatches={category.has_extra_matches}
            layoutKey={category.id}
        />
    );
};

export default App;
